import {useAppSelector} from "@/lib/store.ts";
import {useState} from "react";

export const useMessages = () => {
    const {list: chatRooms} = useAppSelector(s => s.messages);
    const [newChatOpen, setNewChatOpen] = useState(false);

    return {
        chatRooms,

        newChatOpen,
        setNewChatOpen,
    };
}